import type { IdDisposition } from './types.js';

/**
 * Libellés de l'écran. Ce sont des données, pas de la logique : les colonnes du tableau des vivants, les états des
 * branches et les situations des successions se modifient ici (et, à terme, dans les paramètres versionnés de D10).
 */

export const MANQUANT = 'à trouver';
export const A_DEFINIR = 'à définir';
export const A_DETERMINER = 'à déterminer';
/** Coordonnée connue du Cabinet mais réservée à l'équipe : elle ne sort pas dans l'export du notaire. */
export const NON_COMMUNIQUE = 'non communiqué';

export const DISPOSITIONS_DONNEES: readonly { id: IdDisposition; libelle: string; aide: string }[] = [
  {
    id: 'classique',
    libelle: 'Arbre classique',
    aide: 'Des parents vers les enfants, génération par génération. La vue de référence pour le notaire.',
  },
  {
    id: 'eventail',
    libelle: 'Éventail',
    aide: 'Les auteurs au centre, chaque génération sur un cercle. Lisible d’un coup d’œil même avec beaucoup d’héritiers.',
  },
  {
    id: 'branches',
    libelle: 'Par branches',
    aide: 'Une colonne par enfant des auteurs, avec sa quote-part et son état. Montre tout de suite la branche qui bloque.',
  },
  { id: 'liste', libelle: 'Liste', aide: 'Une liste en retrait, facile à lire sur téléphone et à imprimer.' },
  {
    id: 'chemin',
    libelle: 'Chemin d’un héritier',
    aide: 'La seule lignée qui relie un héritier aux auteurs, avec l’explication de sa part. C’est la vue montrée sur son portail.',
  },
];

export const ACCESSIBILITE = { joignable: 'joignable', a_relancer: 'à relancer', injoignable: 'injoignable' } as const;

export const CANAUX = { whatsapp: 'WhatsApp', email: 'E-mail', telephone: 'Téléphone', courrier: 'Courrier' } as const;

export const ETATS_BRANCHE = {
  complete: 'complète',
  a_relancer: 'à relancer',
  bloquee: 'bloque le dossier',
} as const;

export const SITUATIONS_SUCCESSION = {
  ouverte: 'notoriété à faire',
  notoriete_faite: 'notoriété faite',
  close: 'succession close',
  aucune: 'succession à ouvrir',
} as const;

export const STATUTS_CONTACT = {
  accepte: 'a accepté d’être contacté',
  non_accepte: 'n’a pas accepté d’être contacté',
  inconnu: 'pas encore contacté',
} as const;

/** Badge du tableau de l'équipe : la coordonnée existe mais n'est pas montrée à la famille (SYNTHESE §3, correction 4). */
export const BADGE_MASQUEE = 'masquée pour la famille';

/**
 * Statut du résultat juridique (DevolutionResult.status), affiché près des quotes-parts tant que la notaire ne l'a pas
 * validé (SYNTHESE §2). `colonne` sert d'intitulé à la colonne Droits de l'export du notaire.
 */
export const STATUTS_DEVOLUTION = {
  a_valider_notaire: { mention: 'à valider notaire', colonne: 'Droits (à valider notaire)' },
  valide_notaire: { mention: 'validé par la notaire', colonne: 'Droits (validés par la notaire)' },
  remplace: { mention: 'résultat remplacé, à recalculer', colonne: 'Droits (résultat remplacé, à recalculer)' },
} as const;

/** Affiché à la place des quotes-parts quand l'API n'a calculé aucune dévolution. */
export const DEVOLUTION_NON_CALCULEE = 'Dévolution non calculée';
